import { html, View } from 'rune-ts';
import { Localized } from '../../../../../../../shared/type';
import {
  Input_TextEditor,
  InputTextData,
} from '@services/MarppleShopStudio/shared/component/atom/Input/Input_TextEditor.ts';
import klass from './Input.module.scss';
import { EditorInputFocusoutEvent } from '@services/MarppleShopStudio/shared/component/atom/Input/core/events.ts';
import { find, pipe, values, toArray, entries } from '@fxts/core';
import { INTL_ICONS } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/constants.ts';

type InputTextEditorIntlData<TName extends string = string> = Localized<
  InputTextData<TName> & { onFocusout?: (view: Input_TextEditor<TName>) => void }
>;

export class Input_TextEditor_Intl<TName extends string = string> extends View<
  InputTextEditorIntlData<TName>
> {
  private readonly _editors: Localized<Input_TextEditor<TName>> = {
    kr: new Input_TextEditor<TName>({
      ...this.data.kr,
      option: {
        ...this.data.kr?.option,
        icon: INTL_ICONS.kr,
      },
    }),
    en: new Input_TextEditor<TName>({
      ...this.data.en,
      option: {
        ...this.data.en?.option,
        icon: INTL_ICONS.en,
      },
    }),
    jp: new Input_TextEditor<TName>({
      ...this.data.jp,
      option: {
        ...this.data.jp?.option,
        icon: INTL_ICONS.jp,
      },
    }),
  };

  get editors() {
    return this._editors;
  }

  protected override template() {
    return html` <div class="${klass.input_intl_wrap}">${pipe(values(this.editors), toArray)}</div> `;
  }

  protected override onRender() {
    this.addEventListener(EditorInputFocusoutEvent, (event) => {
      const name = event.detail.name;

      pipe(
        entries(this.data),
        find(([, item]) => item.name === name),
        (data) => {
          if (data) {
            const [key, item] = data;
            item.onFocusout?.(this.editors[key]);
          }
        },
      );
    });
  }
}
